import React from 'react';
import { Link } from 'react-router-dom';
import './Homepage.css';
import { FaBell } from 'react-icons/fa';

const HomePage = () => {
  return (
    <div className="homepage-wrapper">

      {/* Notification Banner */}
      <div className="notification-banner">
        <FaBell className="notification-icon" />
        <span>We’re Now Open for sourcing cars. For Just ksh 2,500 and we deliver your perferct car</span>
        <a href="/contact" className="find-us-link">Find Us Here</a>
        <span> - Call Us: <a href="tel:0742077050" className="call-us-link">254742077050</a></span>
      </div>

      {/* Header Section */}
      <header className="homepage-header">
        <h1 className="header-title">Ready to find your dream car without stress?</h1>
        <div className="header-buttons">
          <Link to="/terms" className="explore-button">Car Sourcing</Link>
          <Link to="/cars" className="explore-button">Explore vehicles</Link>
          <Link to="/bikes" className="explore-button">Buy a Bicycle</Link>
        </div>
        <div className="finance-specialists">
        <div className="finance-specialists">
      <img src="https://res.cloudinary.com/dujm7zcpj/image/upload/v1728487161/Screenshot_from_2024-10-09_18-17-28_emzkzl.png" alt="Car" className="car-image" />
      </div>
      </div>
      </header>

      {/* Finance Specialists Section */}
      <div className="car-section">
      <div className="car-text">
        <h1>A car for every purse and purpose</h1>
        <p>
        When it comes to buying a car, the choices can seem endless. From luxury sedans to 
        budget-friendly hatchbacks, there's a car to suit every taste and, more importantly,
         every budget. The phrase "A car for every purse and purpose" rings true today,
          reflecting the diversity of vehicles available to meet different needs and financial situations.

        
        </p>
        <p>Ultimately, whether you're a first-time buyer on a budget or someone looking to splurge,
           there’s a car designed for your specific needs. By focusing on what matters most—be it price, 
           features, or style—you can find the vehicle that’s right for you. No matter your budget, 
           there's a car that perfectly fits your purse and purpose.</p>
        <Link to="/cars" className="explore-button">
          Vehicles
        </Link>
      </div>
      <div className="finance-container">
      <div className="finance-image">
        <img
          src="https://res.cloudinary.com/dujm7zcpj/image/upload/v1728741315/kudus-indonesia-april-19-2024-600nw-2451359799_flcw0o.webp"
          alt="A car"
          className="car-image"
        />
      </div>
    </div>
    </div>
    <div className="finance-container">
      <div className="finance-image">
        <img
          src="https://res.cloudinary.com/dujm7zcpj/image/upload/v1728741673/Screenshot_from_2024-10-12_17-00-55_gaqj6q.png"
          alt="A car"
          className="car-image"
        />
      </div>
      <div className="car-text">
  <h1>Use Our Finance Expertise to Find a Car</h1>
  <p>
    With our tailored financial solutions, we help you find the right car without straining your budget. Our team works with you to understand your financial situation and provide the best financing options available—whether that’s through low-interest loans, flexible payment plans, or even leasing opportunities.
  </p>
  <p>
    The process is simple: you set your budget, and we guide you to vehicles that fit within your monthly spending limits. We’ll help you explore various options, from affordable compact cars to larger family SUVs, ensuring you find a vehicle that meets both your needs and your wallet.
  </p>
  <p>
    Don’t let financial stress hold you back from driving the car of your dreams. With our expertise, you can confidently take the wheel, knowing you’ve made the best decision for both your lifestyle and your finances. Let us help you on your journey to finding the perfect car that matches your budget!
  </p>
  <Link to="/terms" className="explore-button">
    Car Sourcing
  </Link>
</div>

    </div>
    </div>

  );
};

export default HomePage;
